import {
  createResponsibleAsync,
  deleteResponsibleAsync,
  getAllResponsibleByLicenseAsync,
  getResponsibleByIdAsync,
  updateResponsibleAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateResponsibleAsync = () =>
  useMutation(createResponsibleAsync);

export const useGetResponsibleByIdAsync = (
  responsibleIdState?: string | undefined,
) => useMutation(getResponsibleByIdAsync);

export const useGetAllResponsibleByLicenseMutateAsync = () =>
  useMutation(getAllResponsibleByLicenseAsync);

export const useUpdateResponsibleAsync = () =>
  useMutation(updateResponsibleAsync);

export const useDeleteResponsibleAsync = () =>
  useMutation(deleteResponsibleAsync);
